//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DpIcon from '../icon/Icon.vue';
import SimpleInput from '../shared/simpleInput';
import DpInput from './Input.vue';

export default {
  name: 'DpNumberInput',
  components: {
    DpInput,
    DpIcon,
  },
  extends: SimpleInput,
  props: {
    input: { type: Number, default: 0 },
    isNumeric: { type: Boolean, default: true },
    stepSize: { type: Number, default: 1 },
    max: { type: Number, default: Infinity },
    min: { type: Number, default: -Infinity },
  },
  methods: {
    increment() {
      const newValue = Math.min(this.max, this.currentValue + this.stepSize);
      this.handleInput(newValue);
    },
    decrement() {
      const newValue = Math.max(this.min, this.currentValue - this.stepSize);
      this.handleInput(newValue);
    },
  },
};
